import { HttpHeaders } from '@angular/common/http';

const r = /(?:filename=)"?([^"]+)"?(?:;)/;

export function contentDispositionFilename(
  headers: HttpHeaders
): string | null {
  try {
    const contentDisposition = headers.get('content-disposition');
    return (contentDisposition && r.exec(contentDisposition)![1]) || null;
  } catch (e) {
    return null;
  }
}
